import React from "react";
import { Pagination } from "@components";
import { Input,  Select, Radio } from "@components/form";
import {  FormProvider } from 'react-hook-form';
import { useInsResult } from "@hooks";
const InstructorResult = () => {
  const {
    methods, insResult, categoryList, 
    selectedItems, isAllChecked, onSubmit,
    handlePageChange, handleSelectAll, handleSelectItem, handleComplete, handleCancel, handleExcelDownload, resetSearch,
    pageIndex, recordCountPerPage,
  } = useInsResult();



  return (
    <FormProvider {...methods}>
      <form onSubmit={methods.handleSubmit(onSubmit)}>
        <div className="contents-wrap">
          <div className="page-title-wrap">
            <h2><span className="icon-dot-circle"></span>강사 실적 정보</h2>
          </div>

          <div className="tab-cont-wrap">
            <div className="tab-cont-01 on">
              <div className="search-wrap">
                <div className="search-row">
                  <div className="search-item">
                    <label>강의년도</label>
                    <Select
                        name="catgRegYear"
                        options={[
                          { key: "2025", name: "2025년" },
                          { key: "2026", name: "2026년" },
                          { key: "2027", name: "2027년" },
                        ]}
                        defaultOption="전체"
                        className="input-select"
                      />
                    <label style={{marginLeft:"20px"}}>강의분류</label>
                    <Select
                        name="eduCategoryId"
                        options={categoryList?.result}
                        defaultOption="전체"
                        valueKey="eduCategoryId"
                        labelKey="eduCategoryNm"
                        className="input-select"
                      />
                    <label style={{marginLeft:"20px"}}>조회 조건</label>
                    <Select
                      name="searchCnd"
                      options={[
                        { key: "0", name: "강사이름" },
                        { key: "1", name: "강의명" },
                        { key: "2", name: "강의날짜" },
                      ]}
                      defaultOption="전체"
                      className="input-select"
                    />
                    <Input
                      name="searchWrd"
                      placeholder="검색어를 입력하세요"
                      className="input-search"
                      style={{ width: "200px" }}
                    />

                  <label style={{marginLeft:"20px"}}>지급 여부</label>
                    <Radio name="payYn" label="전체" value="" />
                    <Radio name="payYn" label="완료" value="Y" />
                    <Radio name="payYn" label="대기" value="N" />
                  </div>
                  <div className="search-btn-container">
                    <button type="submit" className="btn-search">조회</button>
                    <button type="button" className="btn-reset" onClick={resetSearch}>초기화</button>
                  </div>
                </div>
              </div>

                <section className="section-wrap">
                  <div className="section-tit-wrap">
                    <h3 className="border-left-primary">
                      &nbsp;강사 실적 목록
                      <span className="total-txt">
                        {" "} | 총 <span className="red">{insResult?.totalCount}</span> 건
                      </span>
                    </h3>
                    <div className="btn-right-box">
                      <ul>
                        <li><button type="button" className="btn-excel"  onClick={handleExcelDownload}>엑셀</button></li>
                        <li><button type="button" className="btn-save"  onClick={handleComplete}>지급 완료</button></li>
                        <li><button type="button" className="btn-delete"  onClick={handleCancel} >지급 취소</button></li>
                      </ul>
                    </div>
                  </div>
                  <div className="table-container">
                    <table className="table-list" style={{width:"100%"}}>
                      <colgroup>
                        <col style={{ width: "1%" }} />
                        <col style={{ width: "3%" }} />
                        <col style={{ width: "15%" }} />
                        <col style={{ width: "5%" }} />
                        <col style={{ width: "10%" }} />
                        <col style={{ width: "5%" }} />
                        <col style={{ width: "5%" }} />
                        <col style={{ width: "5%" }} />
                        <col style={{ width: "5%" }} />
                        <col style={{ width: "5%" }} />
                        <col style={{ width: "5%" }} />
                      </colgroup>
                      <thead>
                        <tr>
                          <th> <input type="checkbox" checked={isAllChecked} onChange={handleSelectAll} /> </th>
                          <th>번호</th>
                          <th>강의명</th>
                          <th>강의날짜</th>
                          <th>강사</th>
                          <th>강사연락처</th>
                          <th>시간당 강사료</th>
                          <th>강의시간</th>
                          <th>지급 강사료</th>
                          <th>지급여부</th>
                          <th>내/외부강사</th>
                        </tr>
                      </thead>
                      <tbody>
                        {insResult?.resultList && insResult.resultList.length > 0 ? (
                          insResult.resultList.map((item, idx) => {
                            const rowKey = `${item.lectureId}|${item.eduDt}|${item.instructorId}`;
                            return (
                              <tr key={rowKey}
                              className={item.payYn === 'Y' ? 'row-paid' : ''} 
                              style={{ cursor: "pointer" }}
                              onClick={() => handleSelectItem(rowKey)}>
                                <td onClick={(e) => e.stopPropagation()}>
                                  <input 
                                    type="checkbox" 
                                    checked={selectedItems.includes(rowKey)} 
                                    onChange={() => handleSelectItem(rowKey)}
                                  />
                                </td>
                                <td>{(pageIndex - 1) * recordCountPerPage + idx + 1}</td>
                                <td style={{ textAlign: "left" }}>{item.lectureNm}</td>
                                <td>{item.eduDt}</td>
                                <td>{item.instructorNm} ({item.birthDt})</td>
                                <td>{item.phoneNo}</td>
                                <td>{item.instructPee?.toLocaleString('ko-KR', { style: 'currency', currency: 'KRW' })}</td>
                                <td>{item.eduTime}</td>
                                <td>{item.eduPay?.toLocaleString('ko-KR', { style: 'currency', currency: 'KRW' })}</td>
                                <td>{item.payYn === 'Y' ? '완료' : '대기'}</td>
                                <td>{item.outYn === 'Y' ? '외부' : '내부'}</td>
                              </tr>
                            );
                          })
                        ) : (
                          <tr>
                            <td colSpan={11} style={{ textAlign: 'center' }}>조회 결과가 없습니다.</td>
                          </tr>
                        )}
                      </tbody>
                    </table>
                  </div>
                  {insResult?.paginationInfo && insResult.paginationInfo.totalRecordCount > 0 && (
                      <Pagination
                          totalPages={Math.ceil(
                            insResult.paginationInfo.totalRecordCount / insResult.paginationInfo.recordCountPerPage
                          )}
                          currentPage={pageIndex}
                          onPageChange={handlePageChange}
                          pageRangeDisplayed={10}
                      />
                      )}
                </section>
            </div>
          </div>
        </div>
      </form>
    </FormProvider>
  );
};

export {InstructorResult};
